const GOOGLE_FONTS_STYLESHEET_ID = 'crm-google-fonts-preview';
const BRAND_GOOGLE_FONT_STYLESHEET_ID = 'crm-google-font-brand';

export function buildGoogleFontsStylesheetHref(families: readonly string[]): string {
  const params = families
    .map((family) => `family=${encodeURIComponent(family).replace(/%20/g, '+')}`)
    .join('&');

  return `https://fonts.googleapis.com/css2?${params}&display=swap`;
}

export function ensureGoogleFontsStylesheet(families: readonly string[]): void {
  if (typeof document === 'undefined' || families.length === 0) {
    return;
  }

  const href = buildGoogleFontsStylesheetHref(families);
  let link = document.getElementById(
    GOOGLE_FONTS_STYLESHEET_ID
  ) as HTMLLinkElement | null;

  if (!link) {
    link = document.createElement('link');
    link.id = GOOGLE_FONTS_STYLESHEET_ID;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }

  if (link.href !== href) {
    link.href = href;
  }
}

export function ensureBrandGoogleFont(family: string): void {
  if (typeof document === 'undefined' || !family) {
    return;
  }

  const href = buildGoogleFontsStylesheetHref([family]);
  let link = document.getElementById(
    BRAND_GOOGLE_FONT_STYLESHEET_ID
  ) as HTMLLinkElement | null;

  if (!link) {
    link = document.createElement('link');
    link.id = BRAND_GOOGLE_FONT_STYLESHEET_ID;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }

  if (link.href !== href) {
    link.href = href;
  }
}
